import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-mass-messenger-group-filter-form',
  templateUrl: './mass-messenger-group-filter-form.component.html',
  styleUrls: ['./mass-messenger-group-filter-form.component.scss']
})
export class MassMessengerGroupFilterFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
